// Locale strings of report 2.1 (general-journal-summary), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "General Journal Summary",
  title: "General Journal Summary",
  currencyFilter: "Currency",
  allCurrencies: "All currencies",
  level: "Level",
  levelSummarized: "Summarized (one row per account)",
  levelDetailed: "Detailed (per day)",
  rollUp: "Roll party accounts into their main account",
  section: "Section: {title}",
  sectionHint: "This section must balance on its own",
  entriesCount: "Entries",
  accountsCount: "Accounts",
  net: "Net movement",
  date: "Date",
  side: "Side",
  sideDebit: "Debit",
  sideCredit: "Credit",
  difference: "Difference",
  sectionTotal: "Total ({currency})",
  grandTitle: "Grand total in base currency",
  grandTotal: "Total equivalent ({currency})",
  grandAfterFx: "Total after FX differences ({currency})",
  fxLine: "Currency translation differences",
  totalDebit: "Total debit movements",
  totalCredit: "Total credit movements",
  rolledUp: "Rolled up",
  rolledUpHint: "Includes the movements of {count} sub-accounts",
  showLines: "Show lines",
  hideLines: "Hide lines",
  showDays: "Show days",
  hideDays: "Hide days",
  reference: "Entry no.",
  leafCode: "Sub-account code",
  leafName: "Sub-account name",
  description: "Description",
  linesCount: "Lines",
  pageOf: "Page {page} of {last}",
  previous: "Previous",
  next: "Next",
  reversal: "Reversal",
  reversed: "Reversed",
  notes: "Notes",
  failedLoadEntries: "Could not load the account lines",
  periodRequired: "Please choose the period (from - to)",
  grandSheet: "Grand total",
};
